import { CLASSNAME_HIDDEN } from '@vfde-brix/core';

/**
 * Shows or hides the element with the given ID
 * (toggles the 'brix-is-hidden' class on the element)
 * @param elementId ID of the element
 * @param shouldHide If true, the element will be hidden, otherwise shown.
 * If ommitted, the 'brix-is-hidden' will be toggled
 */
export const toggleElement = (elementId: string, shouldHide?: boolean): void => {
    const element = document.getElementById(elementId);
    element && element.classList.toggle(CLASSNAME_HIDDEN, shouldHide);
};
